import React, {useState} from 'react';
import {Link} from 'react-router-dom';

import {
    Box,
    Button,
    Card,
    CardContent, Container,
    FormControl,
    Grid, IconButton, InputAdornment,
    InputLabel,
    MenuItem, Paper,
    Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    TextField
} from "@mui/material";
import {useSelector} from "react-redux";

import Loading from "../../components/Common/Loading";
import {
    useCreateAudienceMutation, useDeleteAudienceMutation,
    useGetAllAudiencesQuery,
    useUpdateAudienceMutation
} from "../../core/api/audience-api";
import {isAdmin} from "../../core/utils/commonUtils";

import CreateAudienceModal from "./CreateAudienceModal";


import {
    PlayArrow,
    Stop,
    Edit,
    Cancel,
    Analytics,
    Equalizer
} from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";

import {DataGrid} from "@mui/x-data-grid";
import {DataGridPro} from "@mui/x-data-grid-pro";
import { LicenseInfo } from '@mui/x-license';
import ConfirmDialog from "../../components/Common/ConfirmDialogComponent";
LicenseInfo.setLicenseKey('47ddef6db8f484df94839cf56de77581Tz0xMDkwNTcsRT0xNzcyNzU1MTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');


export default function Audience() {
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        isFetching,
        error
    } = useGetAllAudiencesQuery()

    const [confirmOpen, setConfirmOpen] = useState(false);
    const [parameterToDelete, setParameterToDelete] = useState(null);
    const [parameterToDeleteName, setParameterToDeleteName] = useState(null);

    const [createAudience, createAudienceResponse] = useCreateAudienceMutation();
    const [updateAudience, updateAudienceResponse] = useUpdateAudienceMutation();
    const [deleteAudience, deleteAudienceResponse] = useDeleteAudienceMutation();

    const [audienceDialog, setAudienceDialog] = useState(false)
    const [selectedItem, setSelectedItem] = useState(false)

    const handleCreateAudience = () => {
        setSelectedItem(false)
        setAudienceDialog(true)
    }

    const getPlatformTitle = (row) => {
        const platforms = row.filter.includeAny.filter(item => item.parameter === 'platform')
        if(platforms.length>0) return platforms[0].values.join(', ')

    }


    // теперь только открываем диалог и запоминаем, что удаляем
    const handleDeleteParameter = (row) => {
        setParameterToDelete(row.id);
        setParameterToDeleteName(row.title);
        setConfirmOpen(true);
    }

    // вызывается, когда пользователь нажал "Yes" в диалоге
    const handleConfirmDelete = async () => {
        if (parameterToDelete) {
            await deleteAudience(parameterToDelete);
        }
        setParameterToDelete(null);
    }

    const envStateData = useSelector(state => state.data.EnvStateData); // Для отображения текущего статуса
    const isProd = envStateData.isProd

    const columns = [
        {
            field: 'title',
            headerName: 'Title',
            minWidth: 200,
            flex: 1
        },
        {
            field: 'platform',
            headerName: 'Platform',
            width: 150,
            renderCell: (params) => {
                return getPlatformTitle(params.row);
            }
        },
        {
            field: 'targetSize',
            headerName: 'Audience size',
            width: 150,
            renderCell: (params) => {
                if(params.row.statistics?.targetSize === null || params.row.statistics === null) return 'calculating...'
                return parseInt(params.row.statistics?.targetSize);
            }
        },
        {
            field: 'actions',
            headerName: 'Actions',
            minWidth: 100,
            flex:1,
            sortable: false,
            renderCell: (params) => {
                return (
                    <>
                        <IconButton
                            onClick={() => {
                                setSelectedItem(params.row)
                                setAudienceDialog(true)
                            }}
                        >
                            <Edit />
                        </IconButton>
                        {!isProd&&
                        <IconButton
                            aria-label="edit"
                            onClick={() => handleDeleteParameter(params.row)}
                        >
                            <DeleteIcon />
                        </IconButton>
                        }
                    </>
                );
            }
        }
    ];

    return <Box>
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <h1>Audiences</h1>

            <Button variant="contained"
                  onClick={() => handleCreateAudience()}
            >
                Create new Audience
            </Button>
        </Box>

        <Box sx={{ width: '100%' }}>

            <Loading isLoading={isLoading} error={error} isError={error}>
                <DataGrid
                    rows={data || []}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: { pageSize: 25, page: 0 },
                        },
                    }}
                    pageSizeOptions={[25, 50, 100]}

                />

            </Loading>
        </Box>

        {audienceDialog&&<CreateAudienceModal parameters={selectedItem} open={audienceDialog} handleDialogClose={() => {setAudienceDialog(false)}} />}

        <ConfirmDialog
            open={confirmOpen}
            title="You are going to delete"
            content={`You are going to delete parameter "${parameterToDeleteName}". Are you sure?`}
            confirmText="Yes"
            cancelText="No"
            onConfirm={handleConfirmDelete}
            onClose={() => setConfirmOpen(false)}
        />
    </Box>
}